import {ComparativoService} from "@/services/ComparativoService";
import LoadingTab from "../../../components/fields/loading/Loading.vue";
import LoadingBlue from "../../../components/fields/loading-blue/LoadingBlue";
import ComparativoDialog from "./tabs/Diferenca"
import Papa from "papaparse"
import {SnackBarModule} from "@/modules/SnackBarModule";

export default {
    name:"ComparativoDados",
    components: {
        ComparativoService,
        LoadingTab,
        LoadingBlue,
        ComparativoDialog
    },
    data: () => ({
        data:[],
        items: [],
        ferias:[],
        total_tmp_rows:0,
        showModalDiffOpen: false,
        loading: {
            table: false,
            btn: false,
            blue:true,
            csv:false,
            bar:0,
            per:0,
        },
        count_info:{
            em_espera:0,
            aberto:0,
            falhou:0,
            apagar:0,
        },
        file: '',
        idSelected: 0,
        itemsPerPage: 20,
        compareSelectedId:0,
        userId:0,
        content: [],
        content_post: [],
        parsed: false,
        msg:{
            "csv":"Arquivo CSV enviado com sucesso para o servidor e será processado dentro de alguns minutos!"
        },
        form:{},
        submitAllow:false,
        loadingFields: true,
        compareDialog:true,
        page: 1,
        linhas:{
            ComDivergencia:0,
            divergencia:0,
        },
        countLines:0,
        dialog:false,
        status:{
            "aberto":"mdi-clock"
        },
        submitCsvCount:0,
        pageCount: 0,
        comparativo:[],
        comparativo_div:[],
        comparativo_b:[],
        matricula:[],
        showTabFerias:false,
        headers: [
            { text: "Matrícula", value: "matricula", sortable: true },
            { text: "Nome", value: "registro.NOME", sortable: true },
            { text: "Período", value: "periodo", sortable: true },
            { text: "Divergências", value: "diferencas", sortable: true },
            { text: "Ações", value: "actions", sortable: true }
        ],
    }),
    watch: {
        page: function(val) {
            this.page = val;
            this.loadDataInView()
        },
    },
    beforeMount() {
        this.loadDataInView()
        this.loadDataInCount()
        this.ferias_lista()
    },
    mounted() {

        this.initializeForm()

    },
    beforeDestroy () {

    },
    methods:{
        uploadCsvFunction() {

        },
        htmlTo(text) {
            return text+'......';
        },
        goTo(path) {
            this.$router.push(path);
        },
        goReload() {
            this.$router.go(this.$router.currentRoute);
        },
        handleFileUpload( event ){
            this.file = event.target.files[0];
            console.log(this.file);
            this.loading.table = true
            if(this.file.size >= 8388608999999) {
                SnackBarModule("Tamanho do CSV deve ser inferior ou igual a 8MB","error");
                this.loading.table = false
                this.submitAllow = false;
                return;
            } else {
                this.loading.table = false
                this.submitAllow = true;
            }
            this.parseFile();
        },
        cancel() {
            this.items = [];
        },
        parseFile(){
            this.loading.table = true
           Papa.parse( this.file, {
                header: true,
                skipEmptyLines: true,
                complete: function( results ){
                    //const headerCSV = ['MILITAR_OU_CIVIL', 'ATIVO_OU_INATIVO', 'COD_UNIDADE', 'DESC_UNIDADE', 'MATRICULA_DV', 'NOME', 'PGC', 'COD_SIT_FUNC', 'DESC_SIT_FUNC', 'QUADRO', 'COD_UNID_LOTACAO', 'DESC_UNID_LOTACAO', 'TEL_RESIDENCIAL', 'CELULAR', 'ANO_REF', 'DATA_DE_INICIO', 'DATA_TERMINO', 'ABONO', 'ANO_BOL', 'UNID_BOL', 'NUM_BOL', 'TIPO_BOL'];
                    //const valid = results.meta.fields.map(string=>string.trim())
                    this.total_tmp_rows = parseInt(Object.keys(results.data).length)
                    this.content_post = results;
                    this.parsed = true;
                    this.loading.bar = 10;
                    this.submitUpdates();
               }.bind(this)
            } );


        },
        async submitUpdates(){
            this.loading.csv = true;
            const myForm = new FormData();

            myForm.append('csv_upload',JSON.stringify(this.content_post))

            const ret = ComparativoService.submit_csv(myForm)

            ret.then((res) => {
           
                if(res.error) {
                    this.loading.csv = false;
                    this.submitAllow = false;
                    SnackBarModule("SIGP foi enviado com sucesso! Nosso servidor está processando sua requisição.","success");

                }
                setInterval(this.goReload,4000);

                // this.loading.table = false;

            }).catch(() => {
                SnackBarModule("A estrutura do arquivo não atende ao comparativo, por favor, corrija o arquivo para prosseguir","error");
                this.loading.table = false;
            })



        },
       async showModalDiff(matricula,item) {

            this.showModalDiffOpen = true;
            this.matricula = matricula;
            this.comparativo = item;
            /*const test = ComparativoService.findOne(matricula);
            await test.then((res) => {
                console.log(res.content.res);
                this.comparativo['b'] = (res.content.res);
            })*/
           this.comparativo_b = item;
           console.log(this.comparativo_b);
        },
        ferias_lista() {
           // console.log('listar ferias');
            const ret = ComparativoService.list_all_ferias();
            ret.then((res) => {
                console.log('aqui res ferias ',res)
            });
        },
        initializeForm() {
            this.form = {
               // csv_upload: [],
            };
        },
        loadTableIn(tag) {
           // console.log(tag);
            switch (tag) {
                case 'ferias':
                    this.showTabFerias = true;
                    break;
                case 'compare':
                    this.showTabFerias = false;
                    break;
            }
        },
        async clearAllData() {
            this.loading.table = true;
          const ret = await ComparativoService.clearAllData();
          if(ret) {
              SnackBarModule("Arquivos temporários de verificação foram apagados com sucesso!","success");
          }

         // console.log(ret);
          this.resetAll();

        },
        resetAll() {
            this.loading.table = false;
            this.cancel()
            this.loading.bar = 0;
        },
      loadDataInView() {
         const ret = ComparativoService.getTableData();
          ret.then((res) => {
                console.log(res.content.data)
              this.items = res.content.data;
              this.pageCount = res.content.last_page;
              this.totalItems = res.content.total;
              this.data = res.content;
            //  console.log(res.content);
              this.loading.blue = false;
              this.content = res.content;
          })
      },
       async loadDataInCount() {
         const ret = ComparativoService.getTableCount();

          ret.then((res) => {
                console.log(res.content);
              this.count_info.aberto = res.content.res.linhas;
              this.linhas.divergencia = res.content.res.linhas;
              this.loading.bar = 100;//((res.content.res.divergencias / res.content.res.linhas) * 100);
              this.linhas.ComDivergencia = res.content.res.divergencias;
          })
          //  console.log(this.count_info);
      }
    }

}